import { BroadcastChannel } from 'broadcast-channel';
import type { TBankAuthPayload } from 'src/components/AuthNew/hooks/useTBankAuth';
import { isTelegramWebApp } from 'src/helpers/isTelegram';

const isWebView = window.is_webview || false;

/**
 * Обработчик для TBank авторизации в обычном браузере
 */
const handleBrowserTBankAuth = () => {
  const channel = new BroadcastChannel('auth-tbank-code');

  const payload = [
    ...new URLSearchParams(window.location.search).entries(),
  ].reduce((acc, paramTuple) => {
    // eslint-disable-next-line prefer-destructuring
    acc[paramTuple[0]] = paramTuple[1];
    return acc;
  }, {} as TBankAuthPayload);

  payload.redirect_url = `${window.location.origin}/login/tbank`;

  channel.postMessage({
    success: !!(payload.code && payload.session_state),
    payload,
  });

  setTimeout(() => {
    window.close();
  }, 250);
};

/**
 * Обработчик для TBank авторизации в WebView
 */
const handleWebViewTBankAuth = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const hasCode = urlParams.has('code');
  const stateParam = urlParams.get('state');
  const sessionState = urlParams.get('session_state');

  if (hasCode && stateParam && sessionState) {
    try {
      const decodedState = decodeURIComponent(stateParam);

      // Извлекаем путь из state
      const parts = decodedState.split('|');
      const pureState = parts[0];
      const originalPath = parts.length > 1 ? parts[1] : '/main';

      urlParams.set('state', pureState);
      const newQueryString = `?${urlParams.toString()}`;
      const redirectUrl = `${window.location.origin}${originalPath}${newQueryString}`;

      window.location.href = redirectUrl;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error processing TBank callback:', error);
      // При ошибке редирект на главную
      window.location.href = `${window.location.origin}/main`;
    }
  }
};

export const TBankHandler = () => {
  if (isWebView || isTelegramWebApp) {
    handleWebViewTBankAuth();
  } else {
    handleBrowserTBankAuth();
  }
};
